export const SAVE_CLIENT_STATUSES_LIST = 'SAVE_CLIENT_STATUSES_LIST'; 
export const SAVE_CLIENT_STATUS_DETAILS = 'SAVE_CLIENT_STATUS_DETAILS'; 